define('Store.ProductDetails.QuantityPricing.View', [
    'Profile.Model',
    'Store.Item.QuantityPricing.Collection',
    'Backbone',
    'Utils',
    'underscore',
    'quantity_pricing.tpl'
], function StoreQuantityPricingView(
    Profile,
    Collection,
    Backbone,
    Utils,
    _,
    quantityPricingTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: quantityPricingTpl,
        events: {
            'click [data-action="toggle"]': 'toggleAccordion'
        },
        _isOpen: false,

        // @method toggleAccordion Toggle the _isOpen internal flag
        // @return {Void}
        toggleAccordion: function toggleAccordion() {
            this._isOpen = !this._isOpen;
        },
        initialize: function initialize(options) {
            var pdp = options.pdpComponent;
            var itemInfo = pdp.getItemInfo();
            var item = itemInfo && itemInfo.item;
            var internalid = item.internalid;
            var profile = Profile.getInstance();
            var priceScheduleList = [];
            var pricelevel = profile.get('priceLevel');
            var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;

            if (pricelevel !== defaultPricelevel) {
                if (item.onlinecustomerprice_detail && item.onlinecustomerprice_detail.priceschedule &&
                    item.onlinecustomerprice_detail.priceschedule.length) {
                    _.each(item.onlinecustomerprice_detail.priceschedule, function eachPriceLevel(priceSchedule) {
                        var min = priceSchedule && priceSchedule.minimumquantity === 0 ? 1 : priceSchedule.minimumquantity;
                        var max = priceSchedule && priceSchedule.maximumquantity ? priceSchedule.maximumquantity: ''
                        priceScheduleList.push({
                            internalid: item.internalid + '-' + pricelevel + '-' + min + '-' + max,
                            pricing: item.internalid + '',
                            iteminternalid: item.internalid + '',
                            minimumquantity: min + '',
                            maximumquantity: max + '',
                            pricelevel: pricelevel,
                            quantityrange: min + '-' + max,
                            price: priceSchedule.price,
                            price_formatted: priceSchedule.price_formatted
                        })
                    });
                }
                this.collection = new Collection(priceScheduleList);
                return;
            }
            this.collection = new Collection();
            this.listenTo(this.collection, 'sync', this.priceSync);
            this.collection.fetch({ data: {
                parent: internalid,
                store: profile.get('store').get('internalid') || '1'
            } });
        },

        priceSync: function priceSync() {
            this.options.application.trigger('change:priceschedule', this.collection)
            this.render();
        },

        compactPriceSchedule: function compactPriceSchedule(origalPricelevelLines) {
            var index;
            var pricelevelLines = origalPricelevelLines;
            if (pricelevelLines && pricelevelLines.length > 1) {
                for (index = pricelevelLines.length - 1; index >= 1; index--) {
                    if (pricelevelLines[index].get('price') === pricelevelLines[index - 1].get('price')) {
                        pricelevelLines[index - 1].set('maximumquantity', pricelevelLines[index].get('maximumquantity'));
                        pricelevelLines.splice(index, 1);
                    }
                }
            }
            if (pricelevelLines && pricelevelLines.length <= 1) {
                pricelevelLines = null;
            }
            return pricelevelLines;
        },
        getContext: function getContext() {
            var pdp = this.options.pdpComponent;
            var itemInfo = pdp.getItemInfo();
            var selectedMatrixChilds = pdp.getSelectedMatrixChilds();
            var item = itemInfo && itemInfo.item;
            var finalItemId;
            var pricelevelLines;
            var linesAreDifferent;
            if (selectedMatrixChilds && selectedMatrixChilds.length && selectedMatrixChilds.length === 1) {
                item = selectedMatrixChilds[0];
            }

            finalItemId = item && item.internalid + '';
            pricelevelLines = finalItemId && this.collection.where({ iteminternalid: finalItemId });
            linesAreDifferent = _.compact(
                _.uniq(_.map(pricelevelLines, function mapRows(r) {
                    if (r.get('maximumquantity')) {
                        r.set('maximumquantity', r.get('maximumquantity') - 1)
                    }
                    return r.get('price');
                }))
            ).length > 1;

            if (item && item.saleunit !== 'Unit') {
                pricelevelLines.shift();
            }
            pricelevelLines = this.compactPriceSchedule(pricelevelLines);

            return {
                isAccordion: true,
                isOpen: this._isOpen,
                showContent: !Profile.getInstance().hidePrices() && pricelevelLines && pricelevelLines.length > 1 && linesAreDifferent,
                priceSchedule: pricelevelLines,
                isModal: false,
                // @property {String} itemKey
                itemKey: finalItemId,
                // @property {String} title
                title: Utils.translate('Quantity discounts available')
            };
        }
    });
});
